/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { useDispatch } from 'react-redux'
import { cancel_button, confirm_buttom, confirm_p, popup_padding, save_button } from 'src/config/config'
import { useRemovePortfolioTagFromSolutionMutation } from 'src/graphql/manual/portfolioCustomTagHooks'
import { showToast } from 'src/store/actions/toastAction'

import { ModalCloseButton } from '../global/ModalCloseButton'

interface Props {
  isOpen: boolean
  tagId: string
  tagName: string
  solutionId: number
  solutionDocumentId: string
  onClose: () => void
  onSuccess: (tagId: string) => void
}

export const RemoveTagConfirmModal: React.FC<Props> = ({
  isOpen,
  tagId,
  tagName,
  solutionId,
  solutionDocumentId,
  onClose,
  onSuccess,
}) => {
  const dispatch = useDispatch()
  const [removePortfolioTagFromSolution, { loading }] = useRemovePortfolioTagFromSolutionMutation()

  const handleConfirm = async () => {
    await removePortfolioTagFromSolution({
      variables: {
        tagDocumentId: tagId,
        solutionId: solutionId > 0 ? solutionId : null,
        solutionDocumentId: solutionDocumentId || null,
      },
    })
    dispatch(showToast('Custom tag removed successfully', 'success'))
    onSuccess(tagId)
    onClose()
  }

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="flex flex-col md:w-[620px] w-full md:pl-0 md:pr-0 pl-[10px] pr-[10px]"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="delete-tag-title"
        aria-modal="true"
      >
        <div className="flex flex-row w-full" style={{ zIndex: '10' }}>
          <ModalCloseButton onClose={onClose} className="md:top-[4px] top-[6px] md:right-[9px] right-[-12px]" />
        </div>
        <div className="flex flex-col overflow-hidden  md:w-[600px]  md:mr-[15px] mt-[-20px]">
          <div className={`request-contact-container  flex flex-row w-full ${popup_padding} md:w-[600px]`}>
            <div className={`${confirm_buttom}`}>
              <div className="flex items-center">
                <p className={`${confirm_p}  !pt-0`} style={{ height: 'auto' }}>
                  {'Remove Custom Tag'}
                </p>
              </div>

              <div className="h-[1px] bg-[#DDDDDD]"></div>

              <p className="mt-6 min-w-0 w-full text-[16px] font-secondary text-darkgray break-words">
                Are you sure you want to remove this custom tag?
              </p>

              <div className="mt-6 flex w-full min-w-0 flex-row flex-wrap items-center md:gap-[16px] gap-[8px]">
                <button
                  className={`${save_button}`}
                  type="button"
                  onClick={handleConfirm}
                  disabled={loading}
                  style={{ backgroundColor: loading ? '#B3BBCD' : '#011D58' }}
                >
                  <p className="w-fit text-white">{loading ? 'Removing' : 'Remove'}</p>
                </button>

                <button className={`${cancel_button}`} type="button" onClick={onClose}>
                  <p className="text-[#333333]">Cancel</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
